const useScrollTop = () => {
    const isScrollable = (element: Element) => {
        const overflowY = window.getComputedStyle(element).overflowY;
      return (overflowY === 'scroll' || overflowY === 'auto') && element.scrollHeight > element.clientHeight;
      };
      
      const scrollToTop = () => {
        document.querySelectorAll('*').forEach(element => {
          if (isScrollable(element)) {
            element.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        });
    
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      };

    return {
        scrollToTop
    }
}

export default useScrollTop;